// Generated from insurance-contract.json at 2025-04-18T21:14:12.881Z

import { atom } from 'jotai';
import { CreedInsuranceContract } from "@quantizr-engineering/common/types/insurance-contract";


export interface CreedInsuranceContractState {
    loading: boolean;
    data: CreedInsuranceContract[] | null;
    lastFetched: number | null;
  }

export const creedInsuranceContractAtom = atom<CreedInsuranceContractState>({
  loading: false,
  data: [],
  lastFetched: null,
});
